import React, {Fragment} from "react";
import useGetMsgDataSources from "../views/Proactive/Utilities/hooks/useGetOrgMsgDataSourcesByProactiveChannel";
import BasicSelect from "./BasicSelect";

export default function ProactiveMsgDataSourceSelect({ name, label, placeholder, handleFormSelectChange, queryParam, input, meta, defaultValues }) {
    const { msgDataSources } = useGetMsgDataSources(queryParam);

    return(
        <Fragment>
            <BasicSelect
                name={name}
                label={label}
                placeholder={placeholder}
                options={msgDataSources}
                handleFormSelectChange={handleFormSelectChange}
                input={input}
                meta={meta}
                defaultValues={defaultValues}
            />
        </Fragment>
    )
}